var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('header-image',{key:_vm.bgImage,attrs:{"page-no":_vm.pageNo,"base-url":_vm.baseUrl,"bg-image":_vm.bgImage}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }